import { Bell } from 'lucide-react';

import { definePanel } from '@/app/definePanel';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'notifications',
    title: 'Live events',
    icon: Bell,
    width: { min: 288, default: 288, max: 480, fill: false },
    // Both modes, matching its universal coexistence: a drawer that overlays any
    // workflow must not FORCE a mode when opened — a single-mode panel pins the
    // open to its sole mode, which from a dirty camera-settings form would evict
    // the form. Alerts also genuinely matter mid-configuration.
    modes: [PanelMode.View, PanelMode.Settings],
    themes: PanelTheme.Any,
    // Live and historic share screen real estate fine — Live events is a
    // small ephemeral drawer over the WebRTC bus; the DB-backed `events_list`
    // is a long historic list that competes with `objects_list` for the
    // "primary list" slot. So Live events has no excludes: it is in
    // UNIVERSAL_PANELS (src/app/exclusions.ts), meaning it reads over any
    // workflow instead of taking a seat in each one's compatibility group.
    // Rightmost panel on stage — sits to the right of camera_view (order 100).
    order: 200,
    // A camera opens it, from the view options menu of its tile.
    hasNavButton: false,
    // Follow the same camera the cameras list / camera_view already select.
    urlSyncedProps: ['cameraId'],
});
